import { useFlags } from "launchdarkly-react-client-sdk";

import { useEntitlements } from "src/hooks/use-entitlement";
import { useOrganizationEntitlement } from "src/hooks/use-organization-entitlement";

/**
 * Whether Match Booster is available to the workspace.
 *
 * Three reads, deliberately — same pattern as use-agents-tier. The server's is
 * the only one that sees a staff grant from the Entitlement Center; grants live
 * in the entitlement_grants table, which the org entitlements jsonb and
 * LaunchDarkly know nothing about. The flag and jsonb reads are synchronous, so
 * they keep this answering correctly before the query resolves rather than
 * flashing the upsell on first render.
 */
export const useMatchBoosterEnabled = (): boolean => {
  const { appMatchBoosting } = useFlags();
  const hasOrgEntitlement = useOrganizationEntitlement("matchbooster");
  const { data } = useEntitlements(true);

  return Boolean(
    appMatchBoosting || hasOrgEntitlement || data.entitlements.matchbooster,
  );
};
